import React from "react";

const TextInput = ({
  label,
  name,
  type,
  placeholder,
  value,
  onChange,
  error,
}) => (
  <div className="w-full">
    <h5 className="paragraph-CK">{label}</h5>
    <div className="text-input mt-1.5 relative">
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        className={`placeholder:text-base placeholder:font-normal placeholder:leading-6 ${
          error ? "input-error" : "input-default"
        }`}
        value={value}
        onChange={onChange}
      />
      {error && <p className="absolute text-red-500 text-xs">{error}</p>}
    </div>
  </div>
);

export default TextInput;
